// default columns definition for nedeed view
export const defaultColumnsGeneral = [
    "orderDetailId",
    // "prodFamilyId",
    // "plantProdFamilyId",
    "designerDetail",
    "designerChecker",
    "esoistatusDesc",
    "itemType",
    "pcl",

    //Remove this field after asking Adan to adjust compare codes endpoint to use only PCL    
    "code"
  ];

  export const defaultColumnsNewOrders = [
    "orderDetailId",
    "itemType"
  ];  

  export const defaultColumnsMAW = [
    "orderDetailId",
    "isPriority",
    "draftingStartDate",
    "draftingDueDate",
    "so",
    "esoi",
    "designerDetail",
    "designerChecker",
    "esoistatusDesc",
    "checkerEst",
    "detailEst",
    "itemType",
    "buildWeek",
    "orderType",
    "gostatus",
    "description",
    "buildWeek"
  ];  

  export function getVisibleColumns(selected, defaultColumns = defaultColumnsNewOrders) {
    return Array.from(new Set([...defaultColumns, ...selected]));
  }
  